import "./App.css";
import MainMenu from "./Pages/MainMenu";
import CartItem from "./Pages/CartItem";
import Basket from "./Pages/Basket";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import LandingPage from "./Pages/LandingPage";
import OrderRecieved from "./Pages/OrderRecieved";
import Gift from "./Pages/Gift";
import PaymentSuccess from "./Pages/PaymentSuccess";
import Invoice from "./Pages/Invoice";
import FailedTransaction from "./Pages/FailedTransaction";
import PaymentCheck from "./Pages/PaymentCheck";
import NotFound from "./Pages/NotFound";
import CheckoutCart from '../src/Pages/Checkout'
import PaymentCheckMoyasar from "./Components/PaymentCheckMoyasar";
import '@emran-alhaddad/saudi-riyal-font/index.css';
import ScanQr from '../src/Pages/scanQr'
import TableServicesPage from "./Pages/TableServicesPage";
import IdleTimeoutHandler from "./Components/IdleTimeoutHandler";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          
          <Route exact path="/scan" element={<ScanQr />} />
          <Route exact path="/" element={<LandingPage />} />
          <Route exact path="/LandingPage" element={<LandingPage />} />
          <Route exact path="*" element={<NotFound />} />

          <Route exact path="/menu" element={<Navigate to="/menu/meals" replace />} />
          <Route exact path="/menu/meals" element={<MainMenu />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/meals/:id" element={<CartItem />} />
          <Route path="/invoice/:id" element={<Invoice />} />
          <Route path="/failed-payment" element={<FailedTransaction />} />
          <Route exact path="/payment-check" element={<PaymentCheck />} />
          <Route
            exact
            path="payment-check-moyasar"
            element={<PaymentCheckMoyasar />}
          />

          <Route exact path="/order-recieved" element={<OrderRecieved />} />
          <Route exact path="/gift" element={<Gift />} />
          <Route exact path="/cart" element={<Basket />} />
          <Route exact path="/checkOut" element={<CheckoutCart />} />
          <Route exact path="/table-services" element={<TableServicesPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
